import React from 'react';

const BreadcrumbBanner = ({ title }) => {
  return (
    <div className="breadcrumb-banner" style={{
      background: "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/images/banner-bg.jpg')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      padding: "80px 0",
      color: "white",
      textAlign: "center"
    }}>
      <div className="container">
        <h1 className="fw-bold">{title}</h1>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb justify-content-center mt-3">
            <li className="breadcrumb-item"><a href="/" className="text-white text-decoration-none">Home</a></li>
            <li className="breadcrumb-item active text-primary" aria-current="page">{title}</li>
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default BreadcrumbBanner;